import { useState, useCallback, useEffect } from 'react';
import { getAllBrandsFilters } from '../../api/allbrands';
import { getAllIndustries } from '../../api/industries';
import { getAllDepartments } from '../../api/departments';
import cogoToast from 'cogo-toast';

export const useFiltersData = (curQuery, filters) => {
  const [isFetching, setIsFetching] = useState(true);
  const [results, setResults] = useState({});

  const fetchResults = useCallback(async (query, filters) => {
    setIsFetching(true);
    try {
      const resp = await getAllBrandsFilters([['query', query], ...filters]);
      setResults(resp);
    } catch (error) {
      console.error(error);
      cogoToast.error(`There was an issue fetching filters.`);
    } finally {
      setIsFetching(false);
    }
  }, []);

  useEffect(() => {
    fetchResults(curQuery, filters);
  }, [curQuery, filters, fetchResults]);

  return {
    isFetching,
    results
  };
};

export const useIndustries = () => {
  const [isFetching, setIsFetching] = useState(true);
  const [industries, setIndustries] = useState([]);

  const fetchResults = async () => {
    setIsFetching(true);
    try {
      const resp = await getAllIndustries();
      setIndustries(resp);
    } catch (error) {
      console.error(error);
      cogoToast.error(`There was an issue fetching industries.`);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchResults();
  }, []);

  return {
    isFetching,
    industries
  };
};

export const useDepartments = () => {
  const [isFetching, setIsFetching] = useState(true);
  const [departments, setDepartments] = useState([]);

  const fetchResults = async () => {
    setIsFetching(true);
    try {
      const resp = await getAllDepartments();
      setDepartments(resp);
    } catch (error) {
      console.error(error);
      cogoToast.error(`There was an issue fetching departments.`);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchResults();
  }, []);

  return {
    isFetching,
    departments
  };
};
